import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const tableDisplayFieldService = {
    getAll,
    getAllTableColumns,
    getAllTableDisplayFields,
    addTableDisplayField,
    updateTableDisplayField,
    deleteTableDisplayField,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/getAllTableDisplayFields/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllTableColumns(table) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/get-columns/${table}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllTableDisplayFields() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addTableDisplayField(newTableDisplayField) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newTableDisplayField),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateTableDisplayField(tableDisplayFieldItem, tableDisplayFieldId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(tableDisplayFieldItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/update/${tableDisplayFieldId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteTableDisplayField(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-display-fields/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
